var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownArrowWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.862 0.861816L11.8048 1.80463L6.00005 7.60936L0.195312 1.80463L1.13812 0.861816L6.00005 5.72375L10.862 0.861816Z",
  fill: "white"
})));
export { SvgDownArrowWhite as ReactComponent };
export default __webpack_public_path__ + "e723e904ec63e31a78aeb0da5f8c58d1.svg";